import {
  TabGroup as HuiTabGroup,
  TabGroupProps as HuiTabGroupProps,
} from '@headlessui/react';
import { FC } from 'react';

export type TabGroupProps = HuiTabGroupProps;

export const TabGroup: FC<TabGroupProps> = ({ children, ...props }) => (
  <HuiTabGroup {...props}>{children}</HuiTabGroup>
);
